export default __webpack_public_path__ + "static/media/uw4.f29eaa1d.png";